import { LoginPage } from '@/features/auth/components/login-page/LoginPage';

export default LoginPage;
